import { loadScript } from '@/features/payments/gateways/script-loader'
import type { GatewayResult } from '@/features/payments/gateways/types'

export const RAZORPAY_SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js'

export interface RazorpayOptions {
  key: string
  order_id?: string
  subscription_id?: string
  /** paise */
  amount?: number
  currency?: string
  name?: string
  description?: string
  image?: string
  prefill?: Record<string, string>
  notes?: Record<string, string>
  config?: Record<string, unknown>
  retry?: Record<string, boolean>
  theme?: { color?: string }
}

interface RazorpayInstance {
  open(): void
  on(event: 'payment.failed', cb: (e: { error?: { code?: string; description?: string; reason?: string } }) => void): void
}
type RazorpayCtor = new (options: RazorpayOptions & { handler: (r: Record<string, string>) => void; modal: { ondismiss: () => void; escape?: boolean } }) => RazorpayInstance

declare global {
  interface Window {
    Razorpay?: RazorpayCtor
  }
}

const THEME = '#059669'

/** Resolves `success` from the handler, `cancelled` when the modal is dismissed, `failed` on `payment.failed`. */
export async function openRazorpay(options: RazorpayOptions): Promise<GatewayResult> {
  await loadScript(RAZORPAY_SCRIPT)
  const Razorpay = window.Razorpay
  if (!Razorpay) return { outcome: 'failed', message: 'Payment provider unavailable' }
  return new Promise((resolve) => {
    let settled = false
    const done = (r: GatewayResult) => {
      if (!settled) {
        settled = true
        resolve(r)
      }
    }
    const rzp = new Razorpay({
      name: 'LeazePro',
      theme: { color: THEME },
      ...options,
      handler: (r) => done({ outcome: 'success', reference: r.razorpay_payment_id }),
      modal: { ondismiss: () => done({ outcome: 'cancelled' }), escape: true },
    })
    rzp.on('payment.failed', (e) => done({ outcome: 'failed', message: e.error?.description ?? e.error?.reason ?? 'Payment failed' }))
    rzp.open()
  })
}
